import { AddressDetails } from "../smart-components/smart-component-property";
import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import { Scenario } from "src/components/shared-components/class/general-classes/scenario";
import { AppSettings } from "../general-classes/app-settings";


/**
 * This class handle properties of scenario
 */
export class ComponentAdapterScenario extends ComponentAdapterParent implements IComponentLoader {
    private _executeScenarioAddress: AddressDetails = null;
    private _stopScenarioAddress: AddressDetails = null;
    private _id: number = null;
    private _runningStateAddress: AddressDetails = null;

    /**
     * Get the scenario address
     */
    get ExecuteScenarioAddress(): AddressDetails {
        return this._executeScenarioAddress;
    }

    /**
     * Get the scenario stop address
     */
    get StopScenarioAddress(): AddressDetails {
        return this._stopScenarioAddress;
    }

    /**
     * Get the scenario running state address
     */
    get RunningStateAddress(): AddressDetails {
        return this._runningStateAddress;
    }

    constructor() {
        super();
    }

    public fillProperty(listSmartComponentSkills: Array<SmartComponentPropertyDetails>): void {
        this._name = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.SCENARIO_NAME)?.value || "";
        this._id = Number(listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.SCENARIO)?.value) || null;
        this._executeScenarioAddress = this._id !== null
            ? new AddressDetails({
                instanceGUID: AppSettings.INSTANCE_GUID_OMNIA,
                address: "Scenario/" + this._id + "/Execute",
            })
            : null;
        this._stopScenarioAddress = this._id !== null
            ? new AddressDetails({
                instanceGUID: AppSettings.INSTANCE_GUID_OMNIA,
                address: "Scenario/" + this._id + "/Stop",
            })
            : null;
        this._runningStateAddress = this._id !== null
            ? new AddressDetails({
                instanceGUID: AppSettings.INSTANCE_GUID_OMNIA,
                address: "Scenario/" + this._id + "/Running",
            })
            : null;

        this.fillMissingProperty();
        this.fillAddressState();
    }

    public fillMissingProperty(): void {
    }

    public fillAddressState(): void {
        if (this._runningStateAddress) {
            this._listSubscribeAddress.push(this._runningStateAddress);
        }
    }
}